import { startTimeout } from '@ewn/time';

const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

function isFocusable (element) {
  return !element.disabled && !element.hidden;
}

function getFocusable (element) {
  return element.matches(focusableSelector) && isFocusable(element)
    // Element itself is focusable
    ? element
    // Check for focusable child elements
    : Array.from(element.querySelectorAll(focusableSelector)).filter(isFocusable)[0];
}

function createEvent (eventType, bubbles) {
  if ('createEvent' in document) {
    const event = document.createEvent('Event');
    event.initEvent(eventType, bubbles, true);
    return event;
  } else if ('Event' in window) {
    return new Event(eventType, { bubbles, cancelable: true });
  }
}

function triggerFocus (element) {
  const bubbles = 'onfocusin' in element;
  const eventType = bubbles ? 'focusin' : 'focus';
  const event = createEvent(eventType, bubbles);
  element.focus();
  element.dispatchEvent(event);
}

export default {
  inserted (el) {
    const focusable = getFocusable(el);
    if (!focusable) return;
    const trigger = triggerFocus.bind(null, focusable);
    // Popovers aren't triggered without the timeout
    startTimeout(trigger);
  }
};
